import { Oval } from "react-loader-spinner";

const Loader = () => {
  return (
    <div className="loader">
      <Oval color="#E44848" secondaryColor="#E44848" />
    </div>
  );
};

export default Loader;
